var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "toast-container" }, [
    _c("img", {
      staticClass: "toast-icon",
      attrs: { src: _setup.toastIcon(_vm.toast.icon), alt: "icon" },
    }),
    _c("div", [
      _c("div", { staticClass: "toast-title" }, [
        _vm._v(_vm._s(_vm.toast.title)),
      ]),
      _c("div", { staticClass: "toast-message" }, [
        _vm._v(_vm._s(_vm.toast.message)),
      ]),
    ]),
    _c("img", {
      staticClass: "close-icon",
      attrs: {
        src: require("@/assets/images/svg/close-icon.svg"),
        alt: "close icon",
      },
      on: {
        click: function ($event) {
          return _setup.removeToastLogic(_vm.toast)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }